<div [formGroup]="form" class="step">
	<h2>Étape 4 : Maîtrises et Langues</h2>

	@if (form.errors?.['negativeCounts']; as err) {
		<div class="alert alert-danger mt-3">
			@if (err.masteries < 0) {
				<div>Le nombre final de maîtrises ne peut pas être négatif ({{ err.masteries }}).</div>
			}
			@if (err.languages < 0) {
				<div>Le nombre final de langues ne peut pas être négatif ({{ err.languages }}).</div>
			}
		</div>
	}

	<div class="row mt-2">
		<div class="col-md-6 right-sep">
			<h4>Maîtrises</h4>

			<div class="row g-3" formArrayName="masteries">
				@for (ctrl of masteries.controls; track $index; let i = $index) {
					<div class="col-md-4">
						<input
							class="form-control"
							[formControlName]="i"
							placeholder="Maîtrise"
						/>
					</div>
				}
			</div>

			@if (masteries.length === 0) {
				<p class="muted mt-2">Aucune maîtrise pour le moment.</p>
			}
		</div>

		<div class="col-md-6">
			<h4>Langues</h4>

			<div class="row g-3" formArrayName="languages">
				@for (ctrl of languages.controls; track $index; let i = $index) {
					<div class="col-md-4">
						<input
							class="form-control"
							[formControlName]="i"
							placeholder="Langue"
						/>
					</div>
				}
			</div>

			@if (languages.length === 0) {
				<p class="muted mt-2">Aucune langue pour le moment.</p>
			}
		</div>
	</div>
	<div class="modifier-box mt-3">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm"
			(click)="showModifiers = !showModifiers">
			{{ showModifiers ? 'Masquer les modificateurs' : 'Voir les modificateurs' }}
		</button>

		@if (showModifiers) {
			<div class="alert mt-3 mb-0">
				<p class="mb-3 small">
					Ajoutez uniquement les modificateurs correspondant à la race, aux passifs ou à un bonus validé.
				</p>

				<div class="col-12">
					<div class="modifier-card">
						<h6 class="mb-3">Bonus complémentaires</h6>

						<div class="row g-2">
							<div class="col-6 col-md-3">
								<label class="form-label">Maîtrise(s) bonus</label>
								<input class="form-control" formControlName="masteriesModifier" type="number">
							</div>

							<div class="col-6 col-md-3">
								<label class="form-label">Langue(s) bonus</label>
								<input class="form-control" formControlName="languageModifier" type="number">
							</div>

						</div>
					</div>
				</div>
			</div>
		}
	</div>
</div>
